<template>
  <div :class="$style.top">
    <div v-if="user" :class="$style.user">
      <button v-if="!userName" @click="onLogin" :class="$style['user-login']" />
      <div v-else style="padding-top: .18rem;">
        <span>{{ userName }}</span>
        <button @click="onLogout" :class="$style['user-logout']">
          点击登出
        </button>
      </div>
    </div>
    <!-- 下载按钮 -->
    <btn-download style="position: absolute; top: .2rem; right: 4.65rem;" />
    <!-- 分享按钮 -->
    <btn-share style="position: absolute; top: .03rem; right: .3rem;" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BtnDownload, BtnShare } from "@/components/widgets";

export default {
  name: "OverviewTop",
  components: {
    BtnDownload,
    BtnShare
  },
  computed: {
    ...mapGetters(["user"]),
    userName() {
      return this.user && this.user.role_name;
    }
  },
  methods: {
    ...mapActions(["clearToken"]),
    onLogin() {
      this.$emit("login");
    },
    onLogout() {
      this.clearToken();
      location.reload();
    }
  }
};
</script>

<style lang="less" module>
.top {
  .background-fill("./images/top-bg.png");

  height: 1.33rem;
}

.user {
  position: absolute;
  top: 0.2rem;
  right: 1.35rem;
  height: 0.85rem;
  font-size: 0.26rem;
  font-weight: 700;

  &-login {
    .size(2.88rem, 0.85rem);
    .background-fill("./images/top-btn-login.png");

    margin-right: 0.15rem;
  }

  &-logout {
    padding-bottom: 0.06rem;
    border-bottom: 1px solid @text-color;
    margin-left: 0.1rem;
  }
}
</style>
